import IframeTemplate from "../layout/content-templates/iframe/IframeTemplate.tsx";
import { useIntl } from "react-intl";
import useCheckoutLinks from "../../../common/features/checkout/useCheckoutLinks.ts";

export default function OrderHistory() {
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Order History" });
  const { makeCheckoutUrl } = useCheckoutLinks();

  return (
    <IframeTemplate title={title}>
      <iframe title={title} src={makeCheckoutUrl("/order-history")} />
    </IframeTemplate>
  );
}
